module.exports = __webpack_public_path__ + "img/tenant-detail.42c2f108.svg";